import AutomationActivityRouter from './AutomationActivityRouter';

export default AutomationActivityRouter;
